<template lang="pug">
div
  app-display(
    label="É espólio:",
    :content="interessado.espolio ? 'Sim' : 'Não'",
    v-if="interessado.espolio != null"
    :class = "compararInteressado && compararInteressado.mudouEspolioInteressados ? 'text': '' "
  )
  informacoes-pessoa(
    :pessoa="interessado.pessoa",
    :dadosInteressadoRr="dadosInteressadoRr",
    :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
    :rendaFamiliar="interessado.rendaFamiliar",
    :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouPessoa"
    :isProcessoFisico="isProcessoFisico"
  )

  app-collapse(:title="labelSocioRepresentante.titleSocioRepresentante" v-if="interessado.sociosRepresentantesLegais && interessado.sociosRepresentantesLegais.length > 0")
    app-collapse-child(v-for="(socio, index) in interessado.sociosRepresentantesLegais" :title="socio.pessoa.pessoaFisica.nome", :key="socio.id")
      informacoes-pessoa(
        :pessoa="socio",
        :isSocio="true",
        :isSocioRepresentanteLegal="true",
        :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
        :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal  "
        :compararIsSocioRepresentanteLegal = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal"
      )
      listagem-documentos(
        v-if="socio.documentos && socio.documentos.length > 0"
        :documentos="socio.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo",
        ownerDocumento="SOCIO_REPRESENTANTE",
        :idSocio="socio._id || socio.id"
        :compararDocumentos = "compararInteressado && compararInteressado.mudouDocumentosInteressado"
        :versaoCadastro = "versaoCadastro"
      )

  app-divider(label="Endereço do Interessado" v-if="!isReurb && !isProcessoFisico")
    informacoes-endereco.margin-top(:endereco="enderecoInteressado", slot="body", :mudouEndereco = "compararInteressado && compararInteressado.mudouEndereco")

  app-divider(label="Endereços de Correspondência" v-if="isBahia && enderecosCorrespondencia.length")
    div(v-for="(enderecoCorrespondencia, index) in enderecosCorrespondencia", :key="index", slot="body")
      el-col(:span="24")
        app-display(
          label="Identificacao:",
          :content="`${index + 1} - ${enderecoCorrespondencia.identificacao}` || '-'",
          style="margin-bottom: 10px; margin-top: 20px"
          :class = "compararInteressado && compararInteressado.mudouEndereco && compararInteressado.mudouEndereco.mudouIdentificacao ? 'text': '' "
        )
      informacoes-endereco.margin-top(:endereco="enderecoCorrespondencia")
  app-divider(label="Endereço de Correspondência" v-else-if="isBahia && interessado.pessoa.enderecoCorrespondencia")
    informacoes-endereco.margin-top(:endereco="interessado.pessoa.enderecoCorrespondencia", slot="body")
  app-divider(v-if="hasConjuge" label="Cônjuge")
    informacoes-pessoa.margin-top(
      slot="body",
      :pessoa="interessado.conjuge.pessoa || interessado.conjuge",
      :isConjuge="hasConjuge",
      :razaoSocialName="isOnerosoGroup ? 'Razão Social:' : 'Associação/Comunidade:'"
      v-if="!isViuvo"
      :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouConjugeInteressado"
      :isProcessoFisico="isProcessoFisico"
    )
    div(v-else, slot="body")
      app-display(
        label="Possui certidão de óbito?",
        :content="conjuge.temCertidaoObito ? 'Sim': 'Não' ",
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouTemCertidaoObito ? 'text': '' "
      )
      app-display(
        label="CPF:",
        :content="conjuge.pessoaFisica.cpf"
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouCPF ? 'text': '' "
      )
      app-display(
        label="Nome:",
        :content="conjuge.pessoaFisica.nome",
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouNome ? 'text': '' "

      )
  app-divider(v-else, label="Cônjuge")
    div.margin-top(slot="body")
      app-display(
        label="Possui cônjuge?"
        content="Não"
        :class = "compararInteressado && compararInteressado.mudouPossuiConjugeInteressado ? 'text': '' "
      )
  app-divider(v-if="hasFamilia" label="Membros da família" :class="compararInteressado.mudouMembroFamilia ? 'text' : 'titulo' ")
  div
    app-membro-familia(:membros="interessado.membrosFamilia", :appMembroFamiliaComparar = "compararInteressado && compararInteressado.mudouMembroFamilia")

</template>

<script>
import AppDisplayColapse from '../AppDisplayColapse'
import AppDivider from '../AppDivider'
import InformacoesEndereco from './InformacoesEndereco'
import InformacoesPessoa from './InformacoesPessoa'
import AppDisplay from '../AppDisplay'
import ListagemDocumentos from './ListagemDocumentos'
import AppCollapse from '@/components/AppCollapse'
import AppMembroFamilia from '@/components/AppMembroFamiliaComparar'
import AppCollapseChild from '@/components/AppCollapseChild'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'
const { labelVisualizacaoProcesso, tiposProcessoFisico } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    isOnerosoGroup: {
      type: Boolean,
      required: true
    },
    isReurb: {
      type: Boolean,
      required: false
    },
    interessado: {
      type: Object,
      required: true
    },
    compararInteressado: {
      type: Object,
      default: compararReticacoesDefault.mudouInteressadoDTODefault
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },
  components: {
    InformacoesEndereco,
    AppDisplayColapse,
    InformacoesPessoa,
    ListagemDocumentos,
    AppDivider,
    AppDisplay,
    AppCollapse,
    AppCollapseChild,
    AppMembroFamilia
  },
  data () {
    return {
      colapses: ['1'],
      labelSocioRepresentante: labelVisualizacaoProcesso.etapaInteressado,
      tiposProcessoFisico
    }
  },
  computed: {
    isProcessoFisico () {
      return this.tiposProcessoFisico.includes(this.cadastroOriginal.tipo)
    },
    enderecoInteressado () {
      return this.interessado.pessoa.endereco ? this.interessado.pessoa.endereco : {}
    },
    enderecosCorrespondencia () {
      return this.interessado.pessoa.enderecosCorrespondencia && this.interessado.pessoa.enderecosCorrespondencia.length ? this.interessado.pessoa.enderecosCorrespondencia : []
    },
    hasConjuge () {
      if (this.isProcessoFisico) {
        return this.interessado.conjuge?.pessoaFisica?.cpf
      }
      return !!(
        this.interessado.pessoa.pessoaFisica &&
        this.interessado.conjuge &&
        this.interessado?.conjuge?.pessoa?.pessoaFisica?.cpf
      )
    },
    hasFamilia () {
      return this.interessado.pessoa.pessoaFisica && !(!this.interessado?.membrosFamilia)
    },
    isViuvo () {
      if (!this.interessado.pessoa.pessoaFisica) {
        return false
      }
      return this.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO'
    },
    conjuge () {
      return this.interessado.conjuge?.pessoa ? this.interessado.conjuge?.pessoa : this.interessado?.conjuge
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    },

    dadosInteressadoRr () {
      const { possuiFilhoMenor, profissao, tipoRegimeEmpregaticio } = this.interessado
      return { possuiFilhoMenor, profissao, tipoRegimeEmpregaticio }
    }
  }

}
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}

@media (max-width: 780px) {
  .margin-top {
    display: flex;
    flex-direction: column;
    width: 490px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesInteressado.vue